import { once } from 'lodash-es';
import Agent from '../models/agent';

export default class Language {
  static agent = new Agent();

  static loadGoogleTranslate = once(({ language = 'en' }) => {
    // @ts-expect-error
    if (!window.google || !window.google.translate) {
      const script = document.createElement('script');
      script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;
      document.body.appendChild(script);
    }

    // @ts-expect-error
    window.googleTranslateElementInit = () => {
      // Create a hidden container for Google Translate
      let translateContainer = document.getElementById('hidden-google-translate');
      if (!translateContainer) {
        translateContainer = document.createElement('div');
        translateContainer.id = 'hidden-google-translate';
        translateContainer.style.display = 'none';
        document.body.appendChild(translateContainer);
      }

      // @ts-expect-error
      new window.google.translate.TranslateElement(
        { pageLanguage: 'en' },
        'hidden-google-translate'
      );

      // Observe changes in the translated content
      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          // @ts-expect-error
          if (mutation.type === 'childList' || mutation.type === 'subtree') {
            this.onFirstTranslation(language);
            observer.disconnect(); // Stop observing after the first translation
            break;
          }
        }
      });

      // Start observing the hidden translate container
      setTimeout(() => {
        const comboElement = document.querySelector('.goog-te-combo');
        if (comboElement) {
          observer.observe(comboElement, {
            childList: true,
            subtree: true
          });
        }
      }, 1000);
    };
  });

  static onFirstTranslation(language) {
    setTimeout(() => {
      // @ts-expect-error
      const value = document.querySelector('.goog-te-combo')?.value;

      if (!value && language && value !== language && language !== 'en') {
        this.triggerTranslateTo(language);
      }

      document.querySelector('.goog-te-combo')?.addEventListener('change', (e) => {
        // @ts-expect-error
        const language = e?.target?.value;

        this.agent.update({ meta: { ...this.agent.props.meta, language } });
      });
    }, 500);
  }

  static triggerTranslateTo(language) {
    const selectField = document.querySelector('.goog-te-combo');

    if (selectField) {
      // @ts-expect-error
      selectField.value = language;
      selectField.dispatchEvent(new Event('change'));
    }
  }
}
